import * as React from 'react';

import FileVector32 from './FileVector32';

export const fileVector32 = () => <FileVector32 />;

export default {
    title: 'Icon|Content|FileVector32',
    component: FileVector32,
    parameters: {
        notes: "`import FileVector32 from 'box-ui-elements/es/icon/content/FileVector32';`",
    },
};
